import { ModelApiService } from './BaseApiService'

export default class TimesheetsApiService extends ModelApiService {
  constructor() {
    super('timesheets')
  }

  async getTimesheetsSummary(clientIds) {
    const urlArgs = new URLSearchParams(
      clientIds.map((clientId) => ['clientIds', clientId])
    )
    return this.get(`overview?${urlArgs}`)
  }

  async getTimesheetsFilteredByCandidate(candidateId, clientIds) {
    const urlArgs = new URLSearchParams(
      clientIds.map((clientId) => ['clientIds', clientId])
    )
    urlArgs.append('candidateId', candidateId)

    return this.get(`candidate?${urlArgs}`)
  }

  async downloadTimesheetFile(timesheetRecordId) {
    return this.getBlob(`download/${timesheetRecordId}`)
  }
}
